/**
 * Line reveal — descriptive text arrives a line at a time on scroll.
 *
 * Blocks, not letters: rich-text metafields render as paragraphs and lists, and
 * each of those is treated as one line. No character splitting — it wrecks
 * screen-reader output and reads as a gimmick.
 */

function initLineReveal(scope = document) {
  const groups = scope.querySelectorAll('[data-line-reveal]');
  if (!groups.length) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  groups.forEach((group) => {
    if (group.dataset.lineReady) return;
    group.dataset.lineReady = 'true';

    const lines = [...group.children];
    lines.forEach((line) => line.setAttribute('data-line', ''));

    if (reduce || !('IntersectionObserver' in window)) {
      lines.forEach((line) => line.classList.add('is-in'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          // Standard mode fades as one; immersive walks down the block.
          const step = document.documentElement.classList.contains('mode-immersive') ? 90 : 0;
          lines.forEach((line, i) => {
            window.setTimeout(() => line.classList.add('is-in'), i * step);
          });
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    observer.observe(group);

    /* Failsafe — see reveal.js. Lines start at opacity 0; nothing may stay
       hidden indefinitely because an observer didn't fire. */
    window.setTimeout(() => lines.forEach((line) => line.classList.add('is-in')), 2000);
  });
}

initLineReveal();

/* Section markup is replaced wholesale by the theme editor. */
document.addEventListener('shopify:section:load', (event) => initLineReveal(event.target));
